'use client';

import { useA11yStatusMessage } from './provider';

export const A11yStatusMessage = () => {
  const { politeMessage, assertiveMessage } = useA11yStatusMessage();

  return (
    <>
      <div className="sr-only" aria-live="polite">
        {politeMessage}
      </div>
      <div className="sr-only" aria-live="assertive">
        {assertiveMessage}
      </div>
    </>
  );
};
